export const FETCH_EMAILS = 'FETCH_EMAILS' as const;
export const FETCH_EMAILS_SUCCESS = 'FETCH_EMAILS_SUCCESS' as const;
export const FETCH_EMAILS_FAIL = 'FETCH_EMAILS_FAIL' as const;
export const FETCH_EMAILS_CANCEL = 'FETCH_EMAILS_CANCEL' as const;
export const CLEAR_EMAILS = 'CLEAR_EMAILS' as const;

export const FETCH_EMAIL_DETAIL = 'FETCH_EMAIL_DETAIL' as const;
export const FETCH_EMAIL_DETAIL_SUCCESS = 'FETCH_EMAIL_DETAIL_SUCCESS' as const;
export const FETCH_EMAIL_DETAIL_FAIL = 'FETCH_EMAIL_DETAIL_FAIL' as const;
export const FETCH_EMAIL_DETAIL_CANCEL = 'FETCH_EMAIL_DETAIL_CANCEL' as const;

export const SEND_EMAIL = 'SEND_EMAIL' as const;
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS' as const;
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL' as const;
export const SEND_EMAIL_CANCEL = 'SEND_EMAIL_CANCEL' as const;

export const FETCH_EMAILS_PAGE = 'FETCH_EMAILS_PAGE' as const;
